// validationSchema.js
import * as Yup from "yup";
export const MAX_FILES = 5;

export const validationSchema = Yup.object({
  name: Yup.string().required("El nombre es requerido"),
  lastname: Yup.string().required("El apellido es requerido"),
  email: Yup.string()
    .email("Correo electrónico inválido")
    .required("El correo electrónico es requerido"),
  confirmEmail: Yup.string()
    .oneOf([Yup.ref("email"), null], "Los correos electrónicos no coinciden")
    .required("Debes confirmar tu correo"),
  password: Yup.string()
    .test(
      "password-validation",
      "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
      function (value) {
        if (!value || value.trim() === "") {
          return this.createError({
            message:
              "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length < 8) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length > 12) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[A-Z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[a-z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/\d/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/^[A-Za-z0-9]+$/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        return true;
      }
    )
    .required("La contraseña es requerida"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Las contraseñas no coinciden")
    .required("Debes confirmar tu contraseña"),
  doc_type: Yup.string().required("El tipo de documento es requerido"),
  doc_number: Yup.string().required("El número de documento es requerido"),
  confirmDocNumber: Yup.string()
    .oneOf(
      [Yup.ref("doc_number"), null],
      "Los números de documento no coinciden"
    )
    .required("Debes confirmar tu número de documento"),
  phone: Yup.string().required("El teléfono es requerido"),
  birthday: Yup.date().required("La fecha de nacimiento es requerida"),
  sex: Yup.string().required("El sexo es requerido"),
  device: Yup.string().required("El dispositivo es requerido"),
  accept_terms: Yup.boolean().oneOf(
    [true],
    "Debes aceptar los Términos y Condiciones"
  ),
  accept_privacy: Yup.boolean().oneOf(
    [true],
    "Debes aceptar la Política de Privacidad"
  ),
});

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email("Correo electrónico inválido")
    .required("El correo electrónico es requerido"),
  password: Yup.string()
    .test(
      "password-validation",
      "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
      function (value) {
        if (!value || value.trim() === "") {
          return this.createError({
            message:
              "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length < 8) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length > 12) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[A-Z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[a-z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/\d/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/^[A-Za-z0-9]+$/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        return true;
      }
    )
    .required("La contraseña es requerida"),
});

export const pqrValidationSchema = Yup.object().shape({
  name: Yup.string().required("El nombre es requerido"),
  email: Yup.string()
    .email("Correo inválido")
    .required("El correo es requerido"),
  phone: Yup.string().required("El teléfono es requerido"),
  type_pqr: Yup.string().required("El tipo de PQR es requerido"),
  message: Yup.string().required("El mensaje es requerido"),
  accept_terms: Yup.boolean()
    .oneOf(
      [true],
      "Debes aceptar la Política de Protección de Datos Personales"
    )
    .required("Debes aceptar la Política de Protección de Datos Personales"),
  captcha: Yup.string().required("Por favor, completa el captcha"),
  attachments: Yup.array().max(
    MAX_FILES,
    `Máximo ${MAX_FILES} archivos permitidos`
  ),
});

const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const eticalValidationSchema = Yup.object().shape({
  details: Yup.string().required("El detalle del reporte es requerido"),
  company: Yup.string().required("La entidad a denunciar es requerida"),
  whistleblower: Yup.string().required("El tipo de denunciante es requerido"),
  name: Yup.string()
    .matches(/^[A-Za-z\s]*$/, "Solo se permiten letras")
    .notRequired(),
  email: Yup.string().email("Correo inválido").notRequired(),
  captcha: Yup.string().required("Por favor, completa el captcha"),
  attachments: Yup.array().test(
    "fileSize",
    "El tamaño total de los archivos no debe superar 5 MB",
    (value) => {
      if (!value || value.length === 0) return true;
      const totalSize = value.reduce((acc, file) => acc + file.size, 0);
      return totalSize <= MAX_FILE_SIZE;
    }
  ),
});

export const pseValidationSchema = Yup.object().shape({
  typePerson: Yup.string().required("El tipo de persona es requerido"),
  bank: Yup.string().required("El banco es requerido"),
  firstName: Yup.string().required("El nombre es requerido"),
  lastName: Yup.string().required("El apellido es requerido"),
  documentType: Yup.string().required("El tipo de documento es requerido"),
  documentNumber: Yup.string().required("El número de documento es requerido"),
  email: Yup.string()
    .email("Correo inválido")
    .required("El correo es requerido"),
  phoneNumber: Yup.string().required("El número de móvil es requerido"),
});

export const cardValidationSchema = Yup.object().shape({
  cardName: Yup.string().required("El nombre del titular es requerido"),
  cardNumber: Yup.string()
    .required("El número de tarjeta es requerido")
    .matches(/^[0-9]{12,19}$/, "El número de tarjeta no es válido"),
  expMonth: Yup.string()
    .required("El mes es requerido")
    .matches(/^(0[1-9]|1[0-2])$/, "Ingrese un mes válido (01-12)"),
  expYear: Yup.string()
    .required("El año es requerido")
    .matches(/^[0-9]{4}$/, "Ingrese un año válido"),
  cvc: Yup.string()
    .required("El CVC es requerido")
    .matches(/^[0-9]{3,4}$/, "El CVC no es válido"),
  dues: Yup.string().required("Seleccione las cuotas"),
});

export const editProfileValidationSchema = Yup.object().shape({
  name: Yup.string().required("El nombre es requerido"),
  lastname: Yup.string().required("El apellido es requerido"),
  email: Yup.string()
    .email("Correo inválido")
    .required("El correo es requerido"),
  phone: Yup.string().required("El teléfono es requerido"),
  birthday: Yup.date()
    .required("La fecha de nacimiento es requerida")
    .typeError("La fecha no es válida"),
  sex: Yup.string()
    .oneOf(["M", "F"], "Seleccione un sexo")
    .required("El sexo es requerido"),
  password: Yup.string()
    .test(
      "password-validation",
      "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
      function (value) {
        if (!value || value.trim() === "") {
          // Campo vacío es aceptable si es opcional.
          return true;
        }
        if (value.length < 8) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length > 12) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[A-Z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[a-z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/\d/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/^[A-Za-z0-9]+$/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        return true;
      }
    )
    .notRequired(),

  confirmPassword: Yup.string().when("password", {
    is: (password) => password && password.trim().length > 0,
    then: (schema) =>
      schema
        .oneOf([Yup.ref("password")], "Las contraseñas deben coincidir")
        .required("Confirma la contraseña"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const updatePasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .test(
      "password-validation",
      "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
      function (value) {
        if (!value || value.trim() === "") {
          return this.createError({
            message:
              "La contraseña debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length < 8) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (value.length > 12) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[A-Z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/[a-z]/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/\d/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        if (!/^[A-Za-z0-9]+$/.test(value)) {
          return this.createError({
            message:
              "Debe tener de 8 a 12 caracteres, incluir al menos una letra mayúscula, una minúscula, un número y no contener caracteres especiales",
          });
        }
        return true;
      }
    )
    .required("La contraseña es requerida"),

  confirmPassword: Yup.string().when("password", {
    is: (password) => password && password.trim().length > 0,
    then: (schema) =>
      schema
        .oneOf([Yup.ref("password")], "Las contraseñas deben coincidir")
        .required("Confirma la contraseña"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
